<div #qrCodeHostElement></div>
